import React, { useContext, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { LocaleContext } from 'routes/Router';
import ReusableTabs from 'components/commom/Tab';
import InReviewList from './InReview';
import ApprovedList from './Approved';
import OnHoldList from './OnHold';
import NewRequestList from './NewRequest';

const AdminRequest = () => {
  const { locale } = useContext(LocaleContext);
  const intl = useIntl();
  const [tab, setTab] = useState(1);

  const tabData = [
    { label: intl.formatMessage({ id: 'New Requests' }) },
    { label: intl.formatMessage({ id: 'In review' }) },
    { label: intl.formatMessage({ id: 'Approved' }) },
    { label: intl.formatMessage({ id: 'On Hold' }) },
  ];

  const handleTabChange = (val) => {
    setTab(val);
  };

  return (
    <Row className="bc-FEF9F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
            : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
        }
      >
        <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
          <FormattedMessage id="Requests" />
        </h2>

        <Row className="m-0 p-0">
          <Col md={12} lg={8} className="p-0">
            <div className="pt-24">
              <ReusableTabs
                tabs={tabData}
                defaultTab={tab}
                currentTab={(val) => handleTabChange(val)}
                background={'#864629'}
                color={'#FFFFFF'}
                tabColor={'#A2A2A2'}
                completeColor={'#FFFFFF'}
                boxShadow={'0px 3px 16px 0px #00000014'}
              />
            </div>
          </Col>
        </Row>
        {tab === 1 && <NewRequestList tab={tab} />}
        {tab === 2 && <InReviewList tab={tab} />}
        {tab === 3 && <ApprovedList tab={tab} />}
        {tab === 4 && <OnHoldList tab={tab} />}
      </Col>
    </Row>
  );
};

export default AdminRequest;
